export const getLanguageSpecificProps = (lang: string) => {
  if (lang === "en") {
    return { englishOnly: true };
  } else if (lang === "ar") {
    return { arabicOnly: true };
  } else {
    return {};
  }
};
